@if (!hideAll()) {
  @if (asset(); as asset) {
    <img [src]="asset | assetUrl: asset.version_data.watermark_uuid : 100 | async" alt="" class="head-asset" />
  }
  <h1>Share Asset</h1>
  <div class="main-container">
    <app-share-asset-link [gallery]="gallery()" [asset]="asset()"></app-share-asset-link>
  </div>
}
